import React from "react";
import { useSelector } from "react-redux";
import { Dialog } from "primereact/dialog";
import NewsTable from "../../../../components/dashboard/News/NewsTable";

export default function DashboardNewsDialog({ open, onClose }) {
    const isMobile = useSelector((state) => state.settings.isMobile);
    const mobile = isMobile === 2;

    return (
        <>
            {mobile && (
                <style>{`
                    .dashboard-news-dialog-mobile.p-dialog {
                        margin: 0 !important;
                        position: fixed !important;
                        bottom: 0 !important;
                        left: 0 !important;
                        right: 0 !important;
                        top: auto !important;
                        transform: translateY(0) !important;
                        animation: slideUpNews 0.3s cubic-bezier(0.4, 0, 0.2, 1) forwards;
                    }
                    @keyframes slideUpNews {
                        from {
                            transform: translateY(100%) !important;
                            opacity: 0.5;
                        }
                        to {
                            transform: translateY(0) !important;
                            opacity: 1;
                        }
                    }
                `}</style>
            )}
            <Dialog
                visible={open}
                className={mobile ? "dashboard-news-dialog-mobile" : ""}
                style={{
                    width: mobile ? "100%" : "78%",
                    ...(mobile ? {} : { maxWidth: 1100 }),
                    borderRadius: mobile ? "14px 14px 0 0" : "20px",
                    overflow: "hidden",
                    border: "1px solid rgba(255, 144, 21, 0.1)",
                    boxShadow:
                        "0 24px 80px rgba(0, 40, 128, 0.12), 0 8px 24px rgba(255, 144, 21, 0.06)",
                    background: "rgba(255, 255, 255, 0.92)",
                    backdropFilter: "blur(20px)",
                    WebkitBackdropFilter: "blur(20px)",
                }}
                onHide={onClose}
                header="Actualités"
                draggable={false}
                dismissableMask
                pt={{
                    header: {
                        style: {
                            background:
                                "linear-gradient(135deg, rgba(255, 144, 21, 0.06), rgba(0, 40, 128, 0.04))",
                            borderBottom: "1px solid rgba(255, 144, 21, 0.1)",
                            padding: mobile ? "14px 16px" : "20px 24px",
                        },
                    },
                    headerTitle: {
                        style: {
                            fontWeight: 600,
                            letterSpacing: "-0.02em",
                            fontSize: "1.15rem",
                            color: "#002880",
                        },
                    },
                    closeButton: {
                        style: {
                            borderRadius: "10px",
                            width: mobile ? 44 : 36,
                            height: mobile ? 44 : 36,
                            transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
                            color: "#002880",
                        },
                    },
                    content: {
                        style: {
                            padding: mobile ? "8px 8px 12px" : "20px 24px 24px",
                            background: "transparent",
                        },
                    },
                    mask: {
                        style: {
                            backdropFilter: "blur(4px)",
                            WebkitBackdropFilter: "blur(4px)",
                            backgroundColor: "rgba(0, 40, 128, 0.12)",
                        },
                    },
                }}
            >
                <NewsTable
                    showHeader={true}
                    showAddButton={false}
                    tableHeight={mobile ? 400 : 520}
                />
            </Dialog>
        </>
    );
}
